import { REPORT_VIEW } from '@/shared/constants'
import {
  reportApi,
  periodontalReportApi,
  brushReportApi,
  screeningReportApi,
} from '@/shared/api'
import { AxiosResponseType, ReportViewType } from '@/shared/types'

export const removeReport = async (
  reportType: ReportViewType,
  reportId: number
): AxiosResponseType<any> => {
  switch (reportType) {
    case REPORT_VIEW.plaqueIndex:
      return await reportApi.removeReport(reportId)
    case REPORT_VIEW.periodontal:
      return await periodontalReportApi.removeReport(reportId)
    case REPORT_VIEW.screening:
      return screeningReportApi.removeReport(reportId)
    case REPORT_VIEW.brushMap:
      return await brushReportApi.removeReport(reportId)
  }
}
